import React from 'react';
import Modal from 'components/ModalSecond';
import { SizedLongBody } from 'containers/LoginPage/styles';
import { injectIntl, useIntl } from 'react-intl';
import { useMediaQuery } from '@material-ui/core';
import { StoreContext } from 'utils/contextStore';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { getEmailSelector, getPhoneSelector } from 'store/user/selectors';
import { createFolderMapping } from 'containers/AMCDashboard/DeclareFolderProcess/mapping';
import { postCreateFolderProcess } from 'store/user/apis';
import moment from 'moment';
import { translate } from 'helpers/intl';
import { AssuranceIcon } from 'images';
import DesktopFooter from 'components/FooterModal/desktopFooter';
import MobileFooter from 'components/FooterModal/mobileFooter';
import messages from './messages';

const ModalCreateFlder = ({ isOpen, openModalCreateFolder, ...props }: any) => {
  const {
    declareFolderProcessStepsState,
    concernedPeopleState,
    successTestState,
    checkFirstDeclareState,
    isLoadingDMOState,
    isLoadingParamsState,
    organismeListState,
    mandatoryFilesState,
  } = React.useContext(StoreContext);
  const getStep = declareFolderProcessStepsState?.declareFolderProcessSteps;
  const setStep = declareFolderProcessStepsState?.setDeclareFolderProcessSteps;
  const concernedPeople = concernedPeopleState?.concernedPeople;
  const testSuccessProcess = successTestState?.testSuccessProcess;
  const setSuccessProcess = successTestState?.setTestSuccessProcess;
  const setCheckFirstDeclare = checkFirstDeclareState?.setCheckFirstDeclare;
  const setLoading = isLoadingDMOState?.setIsLoadingDMO;
  const checkFirstDeclare = checkFirstDeclareState?.checkFirstDeclare;
  const isLoadingDMO = isLoadingDMOState?.isLoadingDMO;
  const isLoadingParams = isLoadingParamsState?.isLoadingParams;
  const organismeList = organismeListState?.organismeList;
  const getPhone = useSelector(getPhoneSelector);
  const getEmail = useSelector(getEmailSelector);
  const isNotMobile = useMediaQuery('(min-width:960px)');
  const mandatoryFiles = mandatoryFilesState?.mandatoryFiles;
  const intl = useIntl();

  return (
    <Formik
      initialValues={{
        organisme: '',
        email: getEmail,
        telNumber: getPhone,
        dateConsultation: null,
        token: '',
        sessionsId: '',
        typeDossier: '',
        documentFiles: [],
        mandatoryFiles: [],
      }}
      validationSchema={ProcessSchema(getStep, checkFirstDeclare, intl)}
      onSubmit={(values, actions) => {
        /* istanbul ignore next */
        if (getStep === 5) {
          setLoading(true);
          postCreateFolderProcess(
            createFolderMapping(values, {
              selectedOrganisme: organismeList.find(
                (o: any) => o.NUM_POLICE === values.organisme,
              ),
              concernedPeople: concernedPeople,
              mandatoryFiles,
            }),
          )
            .then((result) => {
              setLoading(false);
              result && setSuccessProcess(result);
            })
            .catch((err) => {
              setLoading(false);
              err && setSuccessProcess(false);
            });
        } else {
          /* istanbul ignore next */
          setStep(getStep + 1);
        }
      }}
    >
      {(FormikProps) => (
        <Modal
          open={isOpen}
          handleOpen={openModalCreateFolder}
          handleClose={
            /* istanbul ignore next */ () => {
              props.closeModalCreateFolder();
              FormikProps.resetForm();
              setStep(0);
              setSuccessProcess(null);
              setCheckFirstDeclare(null);
            }
          }
          header={
            isNotMobile ? (
              <>
                <SizedLongBody weight="500" color="#FAFAFA">
                  {intl.formatMessage({
                    id: 'dashboard_amc.submit_health_request',
                  })}
                </SizedLongBody>
              </>
            ) : (
              <>
                <img
                  alt=""
                  src={AssuranceIcon.Back}
                  onClick={
                    /* istanbul ignore next */ () =>
                      getStep !== 0 &&
                      testSuccessProcess === null &&
                      setStep(getStep - 1)
                  }
                />
                <div style={{ flexDirection: 'column', textAlign: 'center' }}>
                  <SizedLongBody
                    style={{ fontSize: 12 }}
                    weight="300"
                    color="#FAFAFA"
                  >
                    {intl.formatMessage({
                      id: 'dashboard_amc.submit_health_request',
                    })}
                  </SizedLongBody>
                  <SizedLongBody weight="500" color="#FAFAFA">
                    {getMobileTitleStepper(getStep, intl)}
                  </SizedLongBody>
                </div>
              </>
            )
          }
          content={props.content}
          footer={
            testSuccessProcess === null ? (
              isNotMobile ? (
                <DesktopFooter
                  isLoading={isLoadingDMO}
                  isLoadingParams={isLoadingParams}
                  setStep={setStep}
                  getStep={getStep}
                />
              ) : (
                <MobileFooter
                  isLoading={isLoadingDMO}
                  isLoadingParams={isLoadingParams}
                />
              )
            ) : null
          }
        />
      )}
    </Formik>
  );
};
/* istanbul ignore next */
const getMobileTitleStepper = (getStep: number, intl: any) => {
  switch (getStep) {
    case 0:
      return intl.formatMessage({ id: 'dmo.step.resp.1' });
    case 1:
      return intl.formatMessage({ id: 'dmo.step.resp.2' });
    case 2:
      return intl.formatMessage({ id: 'dmo.step.resp.3' });
    case 3:
      return intl.formatMessage({ id: 'dmo.step.resp.4' });
    case 4:
      return intl.formatMessage({ id: 'dmo.step.resp.5' });
    case 5:
      return intl.formatMessage({ id: 'dmo.step.resp.6' });
    default:
      break;
  }
};

const ProcessSchema = (getStep: any, checkFirstDeclare: any, intl: any) => {
  return [
    Yup.object().shape({
      organisme: Yup.string().required(
        translate({ ...messages.requiredField }, { intl }),
      ),
      mandatoryFiles: checkFirstDeclare
        ? Yup.string().required(
            translate({ ...messages.requiredField }, { intl }),
          )
        : Yup.string().notRequired(),
    }),
    Yup.object().shape({
      typeDossier: Yup.string().required(
        translate({ ...messages.requiredField }, { intl }),
      ),
    }),
    Yup.object().shape({
      concernedPeople: Yup.string().required(
        translate({ ...messages.requiredField }, { intl }),
      ),
    }),
    Yup.object().shape({
      documentFiles: Yup.array()
        .required(translate({ ...messages.requiredField }, { intl }))
        .min(1)
        .max(10),
    }),
    Yup.object().shape({
      email: Yup.string()
        .email(translate({ ...messages.errorEmail }, { intl }))
        .required(translate({ ...messages.requiredField }, { intl })),
      telNumber: Yup.string()
        .required(translate({ ...messages.requiredField }, { intl }))
        .matches(
          /(\+212|0)([ \-_/]*)(\d[ \-_/]*){9}/,
          translate({ ...messages.errorPhone }, { intl }),
        ),
      dateConsultation: Yup.string()
        .test(
          'is-42',
          translate({ ...messages.errorDateAnterior }, { intl }),
          (value) => {
            /* istanbul ignore next */
            const selectedDate = moment(value);
            /* istanbul ignore next */
            const diffDate = moment().diff(value, 'days', true);
            /* istanbul ignore next */
            return selectedDate.isValid() && diffDate > 0;
          },
        )
        .required(translate({ ...messages.requiredField }, { intl }))
        .nullable(),
      fraisEngagement: Yup.string()
        .required(translate({ ...messages.requiredField }, { intl }))
        .matches(
          /^[0-9]*[,.]?[0-9][0-9]$/,
          translate({ ...messages.errorAmount }, { intl }),
        ),
    }),
  ][getStep];
};

export default injectIntl(ModalCreateFlder);
